import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getTaxList = createAsyncThunk(
  "get-tax",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("tax/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createTax = createAsyncThunk(
  "create-tax",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("tax", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editTax = createAsyncThunk(
  "edit-tax",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`tax/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateTax = createAsyncThunk(
  "update-tax",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/tax/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteTax = createAsyncThunk(
  "delete-tax",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/tax/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const taxSlice = createSlice({
  name: "tax",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTaxList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTaxList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.taxList;
        state.perPage = action?.payload?.data?.data?.perPage;
        state.total = action?.payload?.data?.data?.total;
      })
      .addCase(getTaxList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default taxSlice.reducer;
